var r;
(function(n) {
  n.TEXT = "text", n.IMAGE = "image", n.ICON = "icon";
})(r || (r = {}));
var E;
(function(n) {
  n.HORIZONTAL = "horizontal", n.VERTICAL = "vertical";
})(E || (E = {}));
var i;
(function(n) {
  n.DEFAULT = "default", n.primary = "primary", n.INFO = "info", n.SUCCESS = "success", n.WARNING = "warning", n.ERROR = "error";
})(i || (i = {}));
var t;
(function(n) {
  n.START = "start", n.CENTER = "center", n.END = "end", n.STRETCHED = "stretched";
})(t || (t = {}));
export {
  r as a,
  i as b,
  E as c,
  t as d
};
